import { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import { BtnSecondary } from "../../Buttons/BtnSecondary";
import "../PopupCommonStyle.css";
import styles from "./Style.module.css";

export const PaymentFeedbackPopup = ({ children, onClose, showCloseButton = true }) => {
  const titleId = useId();
  const popupRef = useRef(null);

  useEffect(() => {
    const previousFocus = document.activeElement;
    popupRef.current?.querySelector("button:not(:disabled)")?.focus({ preventScroll: true });
    return () => {
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      onClose();
    }
    if (event.key !== "Tab") return;
    const controls = popupRef.current.querySelectorAll("button:not(:disabled), a[href]");
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  };

  return createPortal(
    <>
      <div className={styles.backdrop} aria-hidden="true" />
      <div
        className={`popup show ${styles.paymentPopup}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        ref={popupRef}
        onKeyDown={handleKeyDown}
      >
        <div className="popup-header">
          <h2 className="title" id={titleId}>Voucher payment</h2>
        </div>
        <div className={`popup-body ${styles.content} ${showCloseButton ? styles.withFooter : ''}`}>{children}</div>
        {showCloseButton && (
          <div className="popup-footer">
            <BtnSecondary type="button" label="Close" handleClick={onClose} customClass="w-100" />
          </div>
        )}
      </div>
    </>,
    document.body
  );
};
